'use strict';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../components/buttons/Button';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {FileRequirementForm} from '../FileRequirementForm';

export function BaseInfoModalView(props) {
  return (
    <div
      className="InfoModal card full-height-flex modal-auto-centered"
      onClick={stopPropagation}
    >
      <div className="ModalHeader">
        <span>
          {props.headerLabel}
        </span>
      </div>

      <div className="ModalContent">
        <FileRequirementForm
          className="InfoModal__fields"
          fieldClass="InfoModal__field"
          model={props.model}
          isEditing={false}
        />
      </div>

      <div className="ModalFooter ModalFooter__buttons">
        <Button
          className="ModalFooter__cancelButton"
          label={props.closeButtonLabel}
          onClick={props.onClose}
        />
      </div>
    </div>
  );
}

BaseInfoModalView.propTypes = {
  model: T.object.isRequired,
  onClose: T.func.isRequired,

  headerLabel: T.string,
  closeButtonLabel: T.string,
};

BaseInfoModalView.defaultProps = {};

export const InfoModalView = I18nComponent(BaseInfoModalView, [
  {code: 'tasks.info.header.label', prop: 'headerLabel'},
  {code: 'default.close.label', prop: 'closeButtonLabel'},
]);

function stopPropagation(e) {
  e.stopPropagation();
}



// WEBPACK FOOTER //
// ./src/js/requirements/components/InfoModal/InfoModalView.js